export type IssueStatus = (typeof IssueStatus)[keyof typeof IssueStatus];

export const IssueStatus = {
	DRAFT: "DRAFT",
	CREATED: "CREATED",
	IN_PROGRESS: "IN_PROGRESS",
	RESOLVED: "RESOLVED",
	BLOCKED: "BLOCKED",
	WILL_NOT_FIX: "WILL_NOT_FIX",
} as const;
